import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=0f065420&scoped=true"
import script from "./FaqCard.vue?vue&type=script&lang=js"
export * from "./FaqCard.vue?vue&type=script&lang=js"
import style0 from "./FaqCard.vue?vue&type=style&index=0&id=0f065420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f065420",
  null
  
)

export default component.exports